const Menu =  [
    { header: 'level : Saksi' },   
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'pie_chart', 
        meta    : {breadcrumb:false}
    },
    {
        
        title : 'Input Data',
        name : 'hitung',
        icon  : 'touch_app',    
        meta:{breadcrumbs:false}
    },    
    
    //NON MENU
    { title : 'Provinsi', name: 'pages/home',visible: false},
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },
    { group: 'hitung',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'analisis',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
